import FieldbookInstallations from './FieldbookInstallations'

export default FieldbookInstallations
